import { API, Item } from "@thenounproject/lingo-core";
import { createQueryAction } from "../actionCreators";

type Args = {
  sectionId: string | number;
  version: number;
};

type Result = { items: Item[]; total: number };
type NormalizedResult = { items: string[]; total: number };
const [useSectionItems, fetchSectionItems] = createQueryAction<Args, Result, NormalizedResult>(
  {
    entity: "items",
    action: "queryInSection",
    pagingKey: "items",
    denormalize: { entity: null, items: { entity: "items", asset: "assets" } },
    condition: ({ args }) => Boolean(args.sectionId),
    prepareData: data => {
      if (!data) return data;
      return {
        items: data.items.map(i => {
          if (i.asset) {
            return {
              ...i,
              kit: null,
              section: null,
              asset: {
                ...i.asset,
                uploader: null,
                items: null,
              },
            };
          }
          return i;
        }),
        total: data.total,
      };
    },
  },
  async ({ args, paging }) => {
    const res = await API.call<{ section: string }>({
      endpoint: `sections/${args.sectionId}`,
      method: "GET",
      query: {
        limit: 200,
        v: args.version,
        page: paging.page,
      },
    });
    const section = res.entities.sections[res.result.section],
      items = section.items,
      total = section.counts.items;
    return { result: { items, total }, entities: res.entities };
  }
);

export default useSectionItems;
export { fetchSectionItems };
